import Reveal from "./Reveal";
import { aboutStats } from "../data";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-accent mb-5">
            About Obled
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-primary leading-[1.05]">
            A corporation built for mobility, access and international growth.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-muted">
            Obled Corporation brings together practical business solutions designed for local
            communities in the United States and strategic opportunities across Africa.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-6">
            {aboutStats.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="border-l-2 border-accent pl-5"
              >
                <div className="text-4xl font-display font-medium text-primary">{s.value}</div>
                <div className="mt-1 text-sm text-muted">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1} className="relative">
          <img
            src="/assets/boardroom.jpg"
            alt="Modern corporate boardroom"
            loading="lazy"
            className="w-full object-cover aspect-[4/5]"
          />
          <div className="absolute -bottom-5 -left-5 h-24 w-24 obled-gradient hidden md:block" aria-hidden="true" />
        </Reveal>
      </div>
    </section>
  );
}
